import { render } from "./VueUploadMultipleImage.vue?vue&type=template&id=6c5304a9&scoped=true"
import script from "./VueUploadMultipleImage.vue?vue&type=script&lang=js"
export * from "./VueUploadMultipleImage.vue?vue&type=script&lang=js"

import "./VueUploadMultipleImage.vue?vue&type=style&index=0&id=6c5304a9&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c5304a9"]])

export default __exports__